import { makeAutoObservable } from "mobx";
import maxBy from "lodash/maxBy";

export default class RedPacket {
  redPacketId: string = "";
  countryCode: string = "";
  vCode: string = "";
  mobile: string = "";
  redPacketInfo = {
    accountId: 0,
    createdTime: 0,
    currency: "",
    currencyId: 0,
    desc: "string",
    expiredTime: 0,
    id: "string",
    singleAmount: 0,
    status: "",
    takeAmount: 0,
    takeLimit: "",
    takeQty: 0,
    tenantId: 0,
    totalAmount: 0,
    totalQty: 0,
    type: "",
    updatedTime: 0,
    userId: 0,
    username: "",
  };

  // INIT("INIT", "初始化"),
  // FAIL("FAIL", "创建失败"),
  // TIME_OUT_FAIL("TIME_OUT_FAIL", "创建失败(划转超时)"),
  // TAKING("TAKING", "领取中"),
  // EXPIRE_REMAIN("EXPIRE_REMAIN", "过期(未领完)"),
  // EXPIRE_COMP("EXPIRE_COMP", "过期(已领完)"),
  // COMPLETE("COMPLETE", "已领完"),

  receiveInfo = {
    accountId: 0,
    createdTime: 0,
    currencyId: 0,
    fromId: 0,
    id: "",
    isNewUser: 1,
    mobile: "",
    redPacketId: "",
    status: "",
    takeAmount: 0,
    tenantId: 0,
    updatedTime: 0,
    userId: 0,
  };

  recordList = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setRedPacketId(id: string = "") {
    this.redPacketId = id;
    sessionStorage.setItem("red_packet_id", id);
  }

  setMobile(data: string = "") {
    this.mobile = data;
    sessionStorage.setItem("mobile", data);
  }

  setRedPacketInfo(data = {}) {
    this.redPacketInfo = { ...this.redPacketInfo, ...data };
  }

  setReceiveInfo(data = {}) {
    this.receiveInfo = { ...this.receiveInfo, ...data };
  }

  setRecordList(data = []) {
    var bestItem = maxBy(data, (o) => o.takeAmount);
    for(var i=0;i<data.length;++i)//multi best no best
    {
      if(data[i].takeAmount == bestItem.takeAmount && data[i].mobile != bestItem.mobile)
      {
        bestItem = null;
        break;
      }
    }
    this.recordList = data.map((item) => {
      return {
        ...item,
        isBest:
          bestItem && this.redPacketInfo.type === "RANDOM" &&
          data.length === this.redPacketInfo.totalQty &&
          bestItem.mobile === item.mobile,
      };
    });
  }

  setCountryCode(data = "") {
    this.countryCode = data;
    sessionStorage.setItem("country_code", data);
  }

  setVCode(data = "") {
    this.vCode = data;
    sessionStorage.setItem("v_code", data);
  }

  get isNewUser() {
    return this.receiveInfo.isNewUser;
  }

  get isOver() {
    return ["COMPLETE"].indexOf(this.redPacketInfo?.status?.toUpperCase()) > -1;
  }

  get isExpired() {
    return (
      ["EXPIRE_COMP", "EXPIRE_REMAIN"].indexOf(
        this.redPacketInfo?.status?.toUpperCase()
      ) > -1
    );
  }

  get isNormal() {
    return (
      ["COMPLETE", "EXPIRE_COMP", "EXPIRE_REMAIN"].indexOf(
        this.redPacketInfo?.status?.toUpperCase()
      ) === -1
    );
  }
}
